import { render, staticRenderFns } from "./CompanyMenu.vue?vue&type=template&id=3f5a5194&"
import script from "./CompanyMenu.vue?vue&type=script&lang=ts&"
export * from "./CompanyMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports